/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../filters/pagecontext/PageContextEntry'
], function(PageContextEntry) {

	var SynchronizePageContextEntry  = PageContextEntry.extend({
		init: function() {
			SynchronizePageContextEntry.inherited('init', this, arguments);
		},

		setOriginalPageContextEntry: function(entry) {
			this.originalPageContextEntry = entry;
			//Update the id
			this.id = this.getKey();
		},

		getKey: function() {
			return this._getOriginalValue() ? this.originalPageContextEntry.getKey() : SynchronizePageContextEntry.inherited('getKey', this, arguments);
		},

		getPageContextSpecItem: function() {
			return this._getOriginalValue() ? this.originalPageContextEntry.getPageContextSpecItem() : SynchronizePageContextEntry.inherited('getPageContextSpecItem', this, arguments);
		},

		_getOriginalValue: function() {
			return (this.originalPageContextEntry && this.origin === 'filter');
		}
	});

	return SynchronizePageContextEntry;
});
